




import { Vue, Component } from 'vue-property-decorator';
import { getRule } from '../api';
@Component
export default class Rule extends Vue {
  obj: any = {};
  async created() {
    const res = await getRule();
    this.obj = res.data;
  }
}
